(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('clientService', clientService);

    clientService.$inject = [
        '$http',
        '$q',
        'endPoints',
        'authorization',
        'common'
    ];

    function clientService(
        $http,
        $q,
        endPoints,
        authorization,
        common
    ) {

        var insurance = {
            0: 'content/img/aseguradoras/asitur/asitur-imagotipo.png',
            1: 'content/img/aseguradoras/racc/racc-imagotipo.png',
            2: 'content/img/aseguradoras/mapfre/mapfre-imagotipo.png',
            3: 'content/img/aseguradoras/europ/europ-imagotipo.png',
            4: 'content/img/aseguradoras/mm/mm-imagotipo.png',
            5: 'content/img/aseguradoras/race/race-imagotipo.png',
            6: 'content/img/aseguradoras/allianz/allianz-imagotipo.png',
            7: 'content/img/aseguradoras/pelayo/pelayo-imagotipo.png',
            8: 'content/img/aseguradoras/ld/ld-imagotipo.png',
        };

        var fieldNames = {
            352: 'Tipo Orden',
            814: 'Resultado',
            824: 'Tipo Medio',
            201: 'Noct/Fest',
            205: 'Kms Compañia',
            815: 'T. Vehículo',
            817: 'Rep. InSitu',
            202: 'Rep. InSitu',
            826: 'Kms Compañia',
            830: 'Noct/Fest',
            827: 'Número de Bultos',
            828: 'Zona de Recogida',
            829: 'Zona de Entrega',
        };


        var operations = {
            options : [{nombre:'Igual a', id: '='}],
            numeric : [{nombre:'Igual a', id: '='}, {nombre:'Mayor que', id: '>'}, {nombre:'Menor que', id: '<'}],
            bool: [{nombre:'Igual a', id: '='}],
            guid: [{nombre:'Igual a', id: '='}],
            string: [{nombre:'Igual a', id: '='}]
        };

        var entidades = {
            'TAX' : [{nombre:'Órdenes', id: 'ordenTAX'}],
            'GRU' : [{nombre:'Órdenes Asistencia', id: 'ordenGRU'}, {nombre:'Órdenes Logística', id: 'ordenLOG'}]
        };

        var service = {
            getClient: getClient,
			addClient: addClient,
			addCuentaPortal: addCuentaPortal,
			addAseguradoraConexionPendiente: addAseguradoraConexionPendiente,
            getList: getList,
			getBrandLogo: getBrandLogo,
			deleteById: deleteById,
            checkExistingNif: checkExistingNif,
            getTarifaFields: getTarifaFields,
            fieldNames: fieldNames,
            operations: operations,
            addTarifa: addTarifa,
            getTarifaList: getTarifaList,
            entidades: entidades,
            getTarifa: getTarifa,
            getEntidades: getEntidades,
            getTarifasCliente: getTarifasCliente
        };

        return service;

        
        function getBrandLogo(tipo) {
            if(tipo === null){ return 'undefined'; }
            return insurance[tipo] || 'undefined';
        }

		function getList(skip, take, sorting, filters, listaClientesActivos, searchText, frequencyFields) {
			var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.entities.clients + 'getAll' + '?skip=' + skip + '&take=' + take,
				data: {
					'sorting': sorting, 'filters': filters, 'dadosDeBaja': listaClientesActivos,
					'frequencyFields': frequencyFields, 'searchTextByFrequencyFields': searchText
				}
            };
            authorization.setBearerHeader($http);
			$http(request).then(function (response) {
                deferred.resolve(response);
            },
				function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function getEntidades(sector) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.entities.get + '?sector=' + sector
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
            function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function getTarifa(tarifaId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.tarifas.getTarifa + '?tarifaId=' + tarifaId
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
            function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function getClient(clientId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.entities.clients + 'get' + '?clientId=' + clientId
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
            function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function addClient(client, tarifas) {
			var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.entities.clients + 'add',
                data: { cliente: client, tarifas }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
            function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
		}

		function addCuentaPortal(NIF, Email, EmpresaId, AseguradoraId, ClienteId, EmpresaNombre) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.entities.clients + 'addCuentaPortal',
				data: { NIF, Email, EmpresaId, AseguradoraId, ClienteId, EmpresaNombre}
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				deferred.resolve(response.data);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}

		function addAseguradoraConexionPendiente(NIF, Email, EmpresaId, AseguradoraId, CuentaId, ClienteId) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.entities.clients + 'addAseguradoraConexionPendiente',
				data: { NIF, Email, EmpresaId, AseguradoraId, CuentaId, ClienteId }
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				deferred.resolve(response.data);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}

		function deleteById(clientIds) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.entities.clients + 'deleteById',
				data: clientIds
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				deferred.resolve(response.data);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;

		}   

		function checkExistingNif(empresaSelected, cliente) {
			var deferred = $q.defer();
			var request = {
				method: 'GET',
                url: endPoints.entities.clients + 'checkExistingNif' + 
                '?empresaId=' + empresaSelected + '&nif=' + cliente.nif,
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				deferred.resolve(response.data);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
        }
        
        function getTarifaFields(id) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.tarifas.getFields
            };
            if (!common.isNullOrUndefined(id))
                request.url += '?clienteId=' + id;

            authorization.setBearerHeader($http);
			$http(request).then(function (response) {
                deferred.resolve(response);
            },
				function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function addTarifa(tarifa, andConditions, orConditions, tarifaProductos, clientId){
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.tarifas.addTarifa,
                data: { 
                    tarifa, 
                    andConditions, 
                    orConditions, 
                    tarifaProductos,
                    clientId
                }
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
            function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function getTarifaList(id){
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.tarifas.getList + "?clientId=" + id
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
            function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function getTarifasCliente(id) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.tarifas.getTarifasCliente + "?clientId=" + id
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }

    }
})();